import axios from "axios";

//const baseUrl = `http://localhost:1026/vmzApi/`;
const baseUrl = `https://vtz.uvcanngaming.com/`;
//const baseUrl = `/`;
const headers = {
  "Content-Type": "application/json",
  "x-auth": "M@#weh@##dhASD2627@#2024",
};

export const getPacksApi = async (userId) => {
  try {
    if (userId != null) {
      const response = await axios.get(
        `${baseUrl}vtzugApi/auth/getPacks/${userId}`,
      );
      return response.data;
    } else {
      const response = await axios.get(`${baseUrl}vtzugApi/auth/getPacks`);
      return response.data;
    }
  } catch (e) {
    throw e.response.data;
  }
};

export const subApi = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}vtzugApi/auth/sub`, data);
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};

export const getSubStatusApi = async (data) => {
  try {
    const response = await axios.post(
      `${baseUrl}vtzugApi/auth/getSubStatus`,
      data,
    );
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};
export const unsubApi = async (token) => {
  try {
    headers.Authorization = "Bearer " + token;
    const response = await axios.post(`${baseUrl}vtzugApi/user/unsub`, "", {
      headers: headers,
    });
    return response.data;
  } catch (e) {
    throw e.response.data;
  }
};

export const fetchGamesApi = async (language_id = 1) => {
  const response = await axios.get(
    `${baseUrl}api/games?gameType=html&languageId=${language_id}`,
  );
  return response?.data;
};

export const fetchAndroidGamesApi = async (language_id = 1) => {
  const response = await axios.get(
    `${baseUrl}api/games?gameType=android&languageId=${language_id}`,
  );
  return response?.data;
};

export const loginApi = async (ani) => {
  const response = await axios.post(`${baseUrl}api/login`, {
    ani,
  });
  return response.data;
};

export const liveLeaderboardApi = async (token) => {
  const response = await axios.get(`${baseUrl}api/live-leaderboard`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response?.data;
};

export const winnersLeaderboardApi = async (token) => {
  const response = await axios.get(`${baseUrl}api/winners`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response?.data;
};

export const userProfileApi = async (token) => {
  const response = await axios.get(`${baseUrl}api/user-profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response?.data;
};

export const editProfileApi = async (formData, token) => {
  const response = await axios.post(`${baseUrl}api/edit-profile`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response?.data;
};

export const SAVE_PLAYTIME_API = `${baseUrl}api/save-play-time`;
